import { NgModule } from "@angular/core";

import { BadgeListComponent } from "./badge-list.component";

@NgModule({
  imports: [BadgeListComponent],
  exports: [BadgeListComponent],
})
export class BadgeListModule {}
